import React from 'react';
import PropTypes from 'prop-types';
import { NavFragment } from '@paypalcorp/globalnavsdk/NavFragment';

export function RegularFooter({ belowFooter }) {
  return (
    <div className="document-footer">
      <NavFragment type="footer" />
      {belowFooter ? (
        <div className="grid white-plate">
          {belowFooter}
        </div>
      ) : null}
    </div>
  );
}

RegularFooter.propTypes = {
  belowFooter: PropTypes.node,
};

RegularFooter.defaultProps = {
  belowFooter: null,
};
